import { Constants } from 'utils';
import { Api } from './Api';

const getAll = async (page = 1, filter = '') => {
    try {
        const url = `/api/users/?page=${page}&limit=${Constants.USUARIOS}&us_name=${filter}`;
        const { data, headers } = await Api.get(url);

        const users = data.data;
        const total = Number(data.total);

        if (users) {
            return {
                users,
                total
                // total: Number(headers['x-total-count'] || Constants.USUARIOS)
            };
        }
        return new Error('Erro ao listar usuários');
    } catch (error) {
        return new Error(error?.response?.data?.message || 'Erro ao listar usuários');
    }
};

const getById = async (id) => {
    try {
        const { data } = await Api.get(`/api/users/${id}`);
        if (data) {
            return data;
        }
        return new Error('Erro ao listar usuário');
    } catch (error) {
        return new Error(error?.response?.data?.message || 'Erro ao listar usuário');
    }
};

const create = async (payload) => {
    try {
        const { data } = await Api.post('/api/users', payload);
        if (data) {
            return data.id;
        }
        return new Error('Erro ao criar usuário');
    } catch (error) {
        return new Error(error?.response?.data?.detail || 'Erro ao criar usuário');
    }
};

const updateById = async (id, payload) => {
    try {
        await Api.put(`/api/users/${id}`, payload);
    } catch (error) {
        return new Error(error?.response?.data?.detail || 'Erro ao atualizar usuário');
    }
};

const deleteById = async (id) => {
    try {
        await Api.delete(`/api/users/${id}`);
    } catch (error) {
        return new Error(error?.response?.data?.detail || 'Erro ao remover usuário');
    }
};

export const UsersService = { getAll, getById, create, updateById, deleteById };
